import React, { useEffect, useState } from 'react';
import { Button, Card, Col, DatePicker, Form, FormInstance, Input, Row, Select } from 'antd';
import './packing-stock-transfer.css';
import { PackingStockTransferItems } from './packing-stock-transfer-items';
import { PackingStockTransferData } from '@gtpl/shared-models/procurement-management'
import { ItemCategoryDropDownDto, PlantsDropDown } from '@gtpl/shared-models/masters';
import moment from 'moment';
import TextArea from 'antd/lib/input/TextArea';
import { GlobalStatus, UnitRequest } from '@gtpl/shared-models/common-models';
import { SaleOrderDropDownDto } from '@gtpl/shared-models/sale-management';
import { StockService } from '@gtpl/shared-services/procurement';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
const { Option } = Select;
/* eslint-disable-next-line */
export interface PackingStockTransferMainProps {
  plantInfo: PlantsDropDown[];
  itemCategories: ItemCategoryDropDownDto[];
  form: FormInstance<any>;
  // saleOrders: SaleOrderDropDownDto[];
  isSoTransfer: (values:boolean) => void;
  getSaleOrderItems: () => void;
}


export function PackingStockTransferMain(
  props: PackingStockTransferMainProps
) {
  useEffect(() => {
    props.form.setFieldsValue({ transferType: GlobalStatus.NO })
  }, []);
  const [isSo, setIsSo] = useState<boolean>(false);
  const [toPlantHidden, setToPlantHidden] = useState<boolean>(true);
  const [isAgainstSODisabled, setIsAgainstSODisabled] = useState<boolean>(true);
  const [saleOrders, setSaleOrders] = useState<SaleOrderDropDownDto[]>([]);
  const skService = new StockService();
  const soService = new SaleOrderService();
  
  const dropDrownInfo = (key, value) => <Option key={key} value={key}>{value}</Option>

  const changeTransferType = () => {
    const transferType = props.form.getFieldValue('transferType');

    props.form.setFieldsValue({ saleOrderId: null });
    if(transferType=== GlobalStatus.NO){
      setIsSo(false)
      props.isSoTransfer(false);
    }else{
      setIsSo(true);
      getSaleOrder();
      props.isSoTransfer(true);
    }
    props.getSaleOrderItems();
  }

  const getSaleOrderItems = () => {
    props.getSaleOrderItems();
  }

  const getSaleOrder = () => {
    const transferType = props.form.getFieldValue('transferType');
    const plant = props.form.getFieldValue('toPlant');
    if(transferType === GlobalStatus.YES&&plant){
      const req = new UnitRequest(plant,"","StockTransfer");
      soService.getSOsAgainstPlant(req).then((res) => {
        if (res.status) {
          setSaleOrders(res.data);
        } else {
          setSaleOrders([]);
        }
      }).catch((err) => {
        AlertMessages.getErrorMessage(err.message);
        setSaleOrders([]);
      });
    }
  }

  const onChangeTransferType = (val) => {
    if(val == 'INTERNAL'){
      setToPlantHidden(false)
      setIsAgainstSODisabled(false)
      // setIsSo(true)
      // props.form.setFieldsValue({transferType:'NO'})
    }else{
      props.form.setFieldsValue({toPlant:null})
      props.form.setFieldsValue({saleOrderId:null})
      setToPlantHidden(true)
      setIsAgainstSODisabled(true)
      setIsSo(false)
      props.form.setFieldsValue({transferType:'NO'})
    }

  }

  return (
    <>
      <Card>
        <Form form={props.form} layout="vertical">
          <Row gutter={24}>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
              <Form.Item
                name={"transferredDate"}
                label="Date"
                rules={[
                  {
                    required: true,
                    message: `Missing Stock Transferred Date`,
                  },
                ]}
                initialValue={moment()}
              >
                <DatePicker showTime style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
              <Form.Item
                name={"transferMethod"}
                label="Transfer Type"
                rules={[
                  {
                    required: true,
                    message: `Please Select Plant!`,
                  },
                ]}
              >
                <Select
                  placeholder="Select Transfer Type"
                  allowClear
                  showSearch
                  onChange={onChangeTransferType}
                  style={{ width: '100%' }}
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                  <Option label="styleWeighment" value="INTERNAL">INTERNAL</Option>
                    <Option label="styleWeighment" value="EXTERNAL">EXTERNAL</Option>
                </Select>
              </Form.Item>
            </Col>
            {!toPlantHidden ?
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
              <Form.Item
                name={"toPlant"}
                label="To Plant"
                hidden={toPlantHidden}
                rules={[
                  {
                    required: true,
                    message: `Please Select Plant!`,
                  },
                ]}
              >
                <Select
                  placeholder="Select To Plant"
                  allowClear
                  showSearch
                  style={{ width: '100%' }}
                  onSelect={getSaleOrder}
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                  <Option key={'plant'} value={''}>Select To Plant</Option>
                  {props.plantInfo.map(dropData => {
                    return (dropData.plantId != Number(localStorage.getItem('unit_id'))) ? dropDrownInfo(dropData.plantId, dropData.plantName) : '';
                  })}
                </Select>
              </Form.Item>
            </Col>:<></>
            }
            
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
              <Form.Item
                name="transferType"
                label="Against So"
                rules={[
                  {
                    required: true,
                    message: 'Against So is required'
                  },
                ]}

              >
                <Select
                  showSearch
                  disabled={isAgainstSODisabled}
                  placeholder="Select Against So"
                  defaultValue={GlobalStatus.NO}
                  onSelect={changeTransferType}
                >
                  <Option key={0} value={null}>Select Against So</Option>
                  <Option key={1} selected value={GlobalStatus.YES}>{GlobalStatus.YES}</Option>
                  <Option key={2} value={GlobalStatus.NO}>{GlobalStatus.NO}</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 8 }}>
              <Form.Item name="note" label="Note">
                <TextArea showCount />
              </Form.Item>
            </Col>
          {/* </Row> */}
          {/* <Row style={{ display: (isSo) ? 'block' : 'none' }}> */}
            <Col style={{ display: (isSo) ? 'block' : 'none' }} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
              <Form.Item
                name={"saleOrderId"}
                label="SO Number"
                rules={[
                  {
                    required: isSo,
                    message: `Please Select Sale Order!`,
                  },
                ]}
              >
                <Select
                  placeholder="Select Sale Order"
                  allowClear
                  showSearch
                  style={{ width: '100%' }}
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  onSelect={getSaleOrderItems}
                >
                  <Option key={'plant'} value={''}>Select Sale Order</Option>
                  {saleOrders.filter(item=>item.status!='CANCELLED').map(dropData => {
                    return dropDrownInfo(dropData.saleOrderId, dropData.saleOrderNumber);
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>

    </>
  );
}

export default PackingStockTransferMain;